import { gql } from "@apollo/client";

// #region | Station Status
export const GET_STATION_STATUS = gql`
  query StatusEsf($domain: String!, $ids: [Int!]!) {
    station {
      statusEsf(domain: $domain, stationIds: $ids) {
        stationId
        responder_number
        animalId
        stationState
        gateState
        motors {
          terminalId
          status
          totalFeedAmount
          consumedFeedAmount
        }
      }
    }
  }
`;

interface StationMotorStatus {
  terminalId: number,
  status: number,
  totalFeedAmount: number,
  consumedFeedAmount: number
}

export interface StationStatus {
    stationId: number,
    responder_number?: string,
    animalId?: number,
    stationState: number,
    gateState: number,
    motors: StationMotorStatus[]
}

export interface StationStatusResponse {
  station: {
    statusEsf: StationStatus[]
  }
}
// #endregion

// #region | Station Last Visits
export const GET_STATION_LAST_VISITS = gql`
  query LastVisits($domain: String!, $ids: [Int!]!) {
    station {
      lastVisits(domain: $domain, stationIds: $ids) {
        stationId
        lastVisits {
          timestamp
          fk_stations
          fk_animals
          dst_offset
        }
      }
    }
  }
`;

interface StationVisit {
  timestamp: number,
  fk_stations: number,
  fk_animals: number,
  dst_offset: number
}

export interface StationLastVisits {
  stationId: number,
  lastVisits: StationVisit[]
}

export interface StationLastVisitsResponse {
  station: {
    lastVisits: StationLastVisits[]
  }
}
// #endregion 

// #region | Station Last Visit Count
export const GET_STATION_VISIT_COUNT = gql`
  query VisitCount($domain: String!, $ids: [Int!]!) {
    station {
      visitCount(domain: $domain, stationIds: $ids) {
        stationId
        stationVisitCount {
          station_id
          station_visits
          day_offset
        }
      }
    }
  }
`

interface StationVisitCountDay {
  station_id: number,
  station_visits: number,
  day_offset: number
}
export interface StationVisitCount {
  stationId: number,
  stationVisitCount: StationVisitCountDay[]
}

export interface StationVisitCountResponse {
  station: {
    visitCount: StationVisitCount[]
  }
}
// #endregion 

// #region | Station Last Visit Count
export const GET_STATION_CONSUMPTION = gql`
  query ConsumptionByIds($domain: String!, $ids: [Int!]!) {
    station {
      consumptionByIds(domain: $domain, stationIds: $ids) {
        target_id
        consumptions {
          accumulated_amount
          expected_amount
          milestone_day_offset
          fk_components
        }
      }
    }
  }
`

export interface StationConsumption {
  accumulated_amount: number,
  expected_amount: number,
  milestone_day_offset: number,
  fk_components: number
}
export interface StationConsumptions {
  target_id: number,
  consumptions: StationConsumption[]
}

export interface StationConsumptionsResponse {
  station: {
    consumptionByIds: StationConsumptions[]
  }
}
// #endregion 